import axios from 'axios'

export default class {
    urlBase = null
    payload = null
    headers = null

    constructor (urlBase) {
      this.urlBase = urlBase
    }

    async exchange (servidor_ids) {
      let uncached_servidor_ids = servidor_ids; //this.getUncachedServidorIds(servidor_ids)

      if(uncached_servidor_ids.length > 0){
        return new Promise((resolve, reject) => {
          axios.post(`${this.urlBase}/v1/servidor/exchange/`, {
            servidor_ids: [...new Set(uncached_servidor_ids)]
          }).then((response) => {
            let rh_data = {}

            if (response.status === 200) {
              let cached_data = {}; //this.getCachedData()
              response.data.data.RhAPI.forEach(matricula => {
                rh_data[matricula['servidor_id']] = matricula

                if(matricula['servidor_id'] in cached_data === false){
                  cached_data[matricula['servidor_id']] = matricula
                }
              })

              //sessionStorage['rh_data'] = JSON.stringify(cached_data)

              resolve(cached_data)
            }
          }).catch((error) => {
            reject(error)
          })
        })
      } else {
        return new Promise((resolve, reject) => {
          try {
            resolve(this.getCachedData())
          } catch (e) {
            reject(e)
          }
        })
      }
    }

    removeFromCache(servidor_id) {
      let cached_data = this.getCachedData()
      if(servidor_id in cached_data){
        delete cached_data[servidor_id]
      }
      sessionStorage['rh_data'] = JSON.stringify(cached_data)
      return true
    }

    clearRhCache(){
      sessionStorage['rh_data'] = '{}'
    }

    insert_matricula(payload) {
      return new Promise((resolve, reject) => {
        axios.post(`${this.urlBase}/v1/servidor/`, payload)
        .then((response) => {
          if ([200, 201].includes(response.status) === true) {
            resolve(response.data.data.SocialAPI.pf_id)
          }
        }).catch((error) => {
          reject(error)
        })
      })
    }

    getUncachedServidorIds(servidor_ids, cache_ident){
      let cached_data = this.getCachedData()
      let uncached_servidor_ids = []
      servidor_ids.forEach(servidor_id => {
        if(servidor_id in cached_data === false){
          uncached_servidor_ids.push(servidor_id)
        }
      })
      return uncached_servidor_ids
    }

    getCachedData() {
      try {
        return JSON.parse(sessionStorage['rh_data'])
      } catch (error) {
        return {}
      }
    }

    setPayload (payload) {
      this.payload = payload
      return this
    }

    setHeaders (headers) {
      this.headers = headers
      return this
    }
}



// WEBPACK FOOTER //
// ./src/services/rh-service.js